<template>
<div >
    <p class="title">签署合同</p>
    <div>
        <p>1、编辑合同信息。</p>
        <img src="../assets/help/1.7.5-1.jpg" alt="">
        <p>2、点击“编辑合同”，打开编辑合同页面，编辑合同内容。</p>
        <img src="../assets/help/1.7.5-2.jpg" alt="">
        <p>3、点击“转换PDF”，转换完成后，插入主CA锁（如未自动识别，请打开“USBKey管理工具”），点击“签章”，签章完成后，点击“保存签章文件”，点击“确认”完成合同签署。</p>
        <img src="../assets/help/1.7.5-3.jpg" alt="">
        <p>4、完成合同编辑后，点击页面中的“保存”，保存当前页面信息，然后出现“提交”按钮，点击“提交”，点击弹窗中的“确定”，完成提交，等待招标人核验。</p>
        <img src="../assets/help/1.7.5-4.jpg" alt="">
        <img src="../assets/help/1.7.5-5.jpg" alt="">
        <img src="../assets/help/1.7.5-6.jpg" alt="">

    </div>
</div>
</template>
<script>
export default {
    name:'center',
    data(){
        return{
            
        }

    }
}
</script>
<style>

</style>